import { find } from "./base";
const USERS = ["users", "users"];

export const user = (state) => (id) => find(state)(USERS, id);
